export const paymentTypes = ["Готівка", "Карта"];

export const defaultImgUrl =
  "https://plus.unsplash.com/premium_photo-1661962910391-cfe1ea4dfe90?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8dG9vbGJveHxlbnwwfHwwfHx8MA%3D%3D";

export const defaultSections = [
  "Загальнобудівельні",
  "Витратні матеріали",
  "Оздоблювальні матеріали",
  "Інженерні системи",
  "Будівельна хімія",
  "Інструменти",
  "Кріплення",
];
